import axios from "axios";

export default {
  get(paginationString) {
    if (paginationString) {
      return axios.get(`/api/franchises${paginationString.text}`);
    } else {
      return axios.get("/api/franchises");
    }
  },
  store(franchise) {
    return axios.post("/api/franchises", franchise);
  },
  delete(id) {
    return axios.delete(`/api/franchises/${id}`);
  },
  update(id, franchise) {
    return axios.put(`/api/franchises/${id}`, franchise);
  }
};
